import { AggregationConfigOverride } from '@g17eco/types/initiativeUniversalTracker';
import { ValueAggregation } from '@g17eco/core';
import { valueAggregationMap } from '@g17eco/types/disaggregation';

interface AggregationDisplayProps {
  valueAggregation: ValueAggregation;
  aggregationConfig: AggregationConfigOverride | undefined;
}

export const AggregationDisplay = ({ valueAggregation, aggregationConfig }: AggregationDisplayProps) => {
  const childrenMode = aggregationConfig?.modes?.children?.valueAggregation;
  const combinedMode = aggregationConfig?.modes?.combined?.valueAggregation;

  if (!childrenMode || !combinedMode) {
    return (
      <div className='text-ThemeInfoDark'>
        <strong>Aggregation type:</strong> {valueAggregationMap[valueAggregation]}
      </div>
    );
  }

  const isSameMode = combinedMode === childrenMode;

  return (
    <div className='mb-2'>
      {isSameMode ? (
        <div className='text-ThemeInfoDark'>
          <strong>Aggregation type:</strong> {valueAggregationMap[combinedMode as ValueAggregation]}
        </div>
      ) : (
        <>
          <div className='text-ThemeInfoDark'>
            <strong>Combined Aggregation:</strong> {valueAggregationMap[combinedMode as ValueAggregation]}
          </div>
          <div className='text-ThemeInfoDark'>
            <strong>Children Aggregation:</strong> {valueAggregationMap[childrenMode as ValueAggregation]}
          </div>
        </>
      )}
    </div>
  );
};
